// Shared interfaces and logic for ChallengeLeaderboard
export interface LeaderboardEntry {
    userId: string;
    displayName: string;
    email: string;
    rank: number;
    totalProgress: number;
    totalValue: number;
    targetValue: number;
    completionRate: number;
    pointsEarned: number;
    lastUpdated: string;
    organizationName?: string;
    teamName?: string;
}

export interface ChallengeLeaderboardProps {
    challengeId: string;
    challengeTitle: string;
    entries: LeaderboardEntry[];
    currentUserId?: string;
    onClose: () => void;
}

// Shared utility functions
export const getRankIcon = (rank: number) => {
    switch (rank) {
        case 1:
            return '🥇';
        case 2:
            return '🥈';
        case 3:
            return '🥉';
        default:
            return `#${rank}`;
    }
};

export const formatProgress = (progress: number) => {
    return `${Math.round(progress * 100)}%`;
};

export const formatValue = (value: number, target: number) => {
    if (value >= 1000) {
        return `${(value / 1000).toFixed(1)}k / ${(target / 1000).toFixed(1)}k`;
    }
    return `${value} / ${target}`;
}; 